import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class JsonDownloadService {

  constructor() { }
  
  downloadJsonFile(data: any, filename: string): void {
    const json = JSON.stringify(data);
    const blob = new Blob([json], { type: 'application/json' });
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    link.click();

    window.URL.revokeObjectURL(url);
  }
}
